import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { immerable, produce } from 'immer';
import { Map } from 'immutable';

import { HeaderMappingItemEntity } from './header-mapping-item.entity';

export interface IDepotHeaderMappingListExtra
	extends IListColumnConfig<HeaderMappingItemEntity> {
	isFixed?: boolean;
	isSelectable?: boolean;
	isSearchable?: boolean;
	isInGroup?: boolean;
	isVisible?: boolean;
	canBeHidden?: boolean;
	canBeReordered?: boolean;
	canBeChosen?: boolean;
	format?: string;
	visibleIndex?: number;
	visible?: boolean;
	width?: string | number;
}

interface IDepotHeaderMappingListEntity
	extends IListAttrs<HeaderMappingItemEntity> {
	availableColumns: Map<string, IDepotHeaderMappingListExtra>;
}

const entityDefaults: IDepotHeaderMappingListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class HeaderMappingListEntity
	implements
		IDepotHeaderMappingListEntity,
		IListOperations<HeaderMappingListEntity, HeaderMappingItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<IDepotHeaderMappingListExtra>
	): HeaderMappingListEntity {
		const inst = new HeaderMappingListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IDepotHeaderMappingListExtra]>());
		inst.availableColumns = Map(cols);
		return inst;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<HeaderMappingItemEntity>
	> {
		return this.availableColumns;
	}

	public getElements(): Map<string, HeaderMappingItemEntity> {
		return this.elements;
	}

	public setElements(
		elems: Map<string, HeaderMappingItemEntity>
	): HeaderMappingListEntity {
		return produce(this, (draft: HeaderMappingListEntity) => {
			draft.elements = elems;
		});
	}
}
